import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

interface ServiceCardProps {
  icon: IconDefinition;
  title: string;
  description: string;
}

const Card = styled.div`
  background-color: #fff;
  border-radius: var(--border-radius-md);
  padding: var(--spacing-md);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  transition: all var(--transition-medium);
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 35px rgba(212, 175, 55, 0.15);
    
    &:after {
      transform: translateY(0);
    }
  }
  
  &:after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 5px;
    background-color: var(--accent);
    transform: translateY(5px);
    transition: transform var(--transition-medium);
  }
`;

const IconContainer = styled.div`
  margin-bottom: var(--spacing-md);
  width: 60px;
  height: 60px;
  background-color: var(--primary-color);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--accent);
  font-size: 1.5rem;
`;

const CardTitle = styled.h3`
  margin-bottom: var(--spacing-sm);
  font-size: 1.5rem;
`;

const CardDescription = styled.p`
  color: #666;
  line-height: 1.6;
  flex-grow: 1;
`;

const ServiceCard: React.FC<ServiceCardProps> = ({ icon, title, description }) => {
  return (
    <Card>
      <IconContainer>
        <FontAwesomeIcon icon={icon} />
      </IconContainer>
      <CardTitle>{title}</CardTitle>
      <CardDescription>{description}</CardDescription>
    </Card>
  );
};

export default ServiceCard; 